module.exports = __webpack_public_path__ + "static/media/mobile-nav.24b9ab9d.svg";